<div class="mb-4">
  <h5 class="text-[20px] text-heading font-bold mb-1 leading-none">Disbursement List</h5>
  <ul>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.dashboard">Home</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.disbursementNavigator">Disbursement</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] font-semibold font-normal inline-block mr-2">
      List
    </li>
  </ul>
</div>

<div class="bg-white p-4 mb-10">
  <app-acc-table [pagination]="pagination" [haveSpaceBetweenLimitAndSearch]="false">
    <table class="custom-table custom-table-default custom-table-border-row">
      <thead class="text-xs uppercase">
        <tr *ngIf="waitHandler.processing"></tr>
        <tr *ngIf="!waitHandler.processing" class="relaive">
          <th class="bg-gray-50 text-sm whitespace-nowrap">ID</th>
          <th class="bg-gray-50 text-sm whitespace-nowrap">Type</th>
          <th class="bg-gray-50 text-sm whitespace-nowrap">Status</th>
          <th class="bg-gray-50 text-sm whitespace-nowrap">Approver</th>
          <th class="bg-gray-50 text-sm whitespace-nowrap">RequestedBy</th>
          <th class="bg-gray-50 text-sm whitespace-nowrap">requested_date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="waitHandler.processing">
          <td colspan="999">
            <app-acc-loader></app-acc-loader>
          </td>
        </tr>
        <ng-container *ngIf="!waitHandler.processing">
          <ng-container *ngIf="disbList$|async as disbList">
            <tr *ngIf="!disbList.length">
              <td colspan="999" class="bg-white sticky left-0">
                <div class="flex gap-2">
                  No Data found...
                  <div *ngIf="pagination.query" class="text-slate-500">
                    Can't find what your looking for?
                    <a (click)="dialogs.openSearch()" href="javascript:void(0);" class="text-blue-400 underline">
                      Search tips
                    </a>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngFor="let item of disbList">
              <td class="whitespace-nowrap">
                <ng-container [ngSwitch]="item.Type">
                  <a *ngSwitchCase="'Reimbursement'" [routerLink]="[routes.reimbursement, item.ID]"
                    class="whitespace-nowrap">
                    <ng-container [ngTemplateOutlet]="showId"></ng-container>
                  </a>
                  <a *ngSwitchCase="'Liquidation'" [routerLink]="[routes.liquidation, Helper.string.formatId.toId(item.ID, 'LIQ', 5)]"
                    class="whitespace-nowrap">
                    <ng-container [ngTemplateOutlet]="showId"></ng-container>
                  </a>
                  <a *ngSwitchCase="'Cash Advance'" [routerLink]="[routes.cashAdvance, item.ID]"
                    class="whitespace-nowrap">
                    <ng-container [ngTemplateOutlet]="showId"></ng-container>
                  </a>
                </ng-container>
                <ng-template #showId>
                  <i class="fa-light fa-receipt text-md"></i>
                  -
                  <span *ngIf="item.Type != 'Liquidation'" class="underline text-red-500">
                    {{item.ID||''}}
                  </span>
                  <span *ngIf="item.Type === 'Liquidation'" class="underline text-red-500">
                    {{Helper.string.formatId.toId(item.ID, 'LIQ', 5)||''}}
                  </span>
                </ng-template>
              </td>
              <td class="whitespace-nowrap">
                <span class="whitespace-nowrap">{{item.Type||''}}</span>
              </td>
              <td class="whitespace-nowrap">
                <span class="badge badge-default whitespace-nowrap">
                  {{item.Status||'No Status'}}
                </span>

                <ng-container [ngSwitch]="item.RequestStatus">
                  <span *ngSwitchCase="'Approved'" class="badge badge-green whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Disapproved'" class="badge badge-red whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchCase="'Pending'" class="badge badge-yellow whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                  <span *ngSwitchDefault class="badge badge-dark whitespace-nowrap">
                    {{item.RequestStatus||'No Status'}}
                  </span>
                </ng-container>
              </td>
              <td>
                <div class="whitespace-nowrap">
                  <span *ngIf="item.Approver as by">
                    ({{Helper.users.formatUID(by.ID)}}) {{by.LastName}}, {{by.FirstName}}
                  </span>
                </div>
              </td>
              <td>
                <div class="whitespace-nowrap">
                  <span *ngIf="item.RequestedBy as by">
                    ({{Helper.users.formatUID(by.ID)}}) {{by.LastName}}, {{by.FirstName}}
                  </span>
                </div>
              </td>
              <td class="whitespace-nowrap">
                <span class="whitespace-nowrap">{{(item.requested_date|formatDateTime)||''}}</span>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </app-acc-table>
</div>



<!-- <div class="mb-4">
  <h5 class="text-[20px] text-heading font-bold mb-1 leading-none">Disbursed List</h5>
  <ul>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.dashboard">Home</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.disbursementNavigator">Disbursement</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] font-semibold font-normal inline-block mr-2">
      List
    </li>
  </ul>
</div> -->

<!-- <div class="white-container">
  <app-acc-table [pagination]="pagination" [showBulkPrint]="true" tableTitle="Disbursement List" [showTitle]="true">
    <table class="custom-table custom-table-default custom-table-border-row">
      <thead class="text-xs uppercase">
        <tr *ngIf="waitHandler.processing"></tr>
        <tr *ngIf="!waitHandler.processing">
          <th>Disbursement Date</th>
          <th>Transaction Type</th>
          <th class="print-data-false flex-centered">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="waitHandler.processing">
          <td colspan="999">
            <app-acc-loader></app-acc-loader>
          </td>
        </tr>
        <ng-container *ngIf="disbursedList$|async as disbursedList">
          <tr *ngIf="!disbursedList.length">
            <td colspan="999" class="bg-white sticky left-0">
              <div class="flex gap-2">
                No Data found...
              </div>
            </td>
          </tr>
          <tr *ngFor="let item of disbursedList">
            <td>{{item.DisbursementDate|date}}</td>
            <td>{{item.TransacType}}</td>
            <td class="print-data-false flex-centered">
              <button (click)="openViewDetails(item)" class="custom-button-sm">
                <i class="fal fa-eye"></i> View More
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </app-acc-table>
</div> -->